/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrSddcNetwork } from './irrSddcNetwork';
import { IrrSaasNetwork } from './irrSaasNetwork';
import { SaasConfigIrrNetwork } from './saasConfigIrrNetwork';


export interface IrrSaasConfigNetworks { 
    irrNetwork?: SaasConfigIrrNetwork;
    vcdsServiceNetwork?: IrrSaasNetwork;
    sddcNetwork?: Array<IrrSddcNetwork>;
}

